module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalelectricians.com.au/images/review_1-6c9bd72853c2eec3188ea8da9df87534.png";